import { mapActions } from "vuex";
import AppCheckbox from "@/components/AppCheckbox";
import AppIcon from "@/components/AppIcon";
import AppPopover from "@/components/AppPopover";
import PricingAndMarginDataContentRow from "@/components/pricingandmargin/PricingAndMarginDataContentRow";
import { EVENTS, isObjectEmpty } from "@/utils";
export default {
  name: "PricingAndMarginDataContent",
  emits: ["select", "sort", "update", "refresh-page-on-update"],
  components: {
    AppCheckbox,
    AppIcon,
    AppPopover,
    PricingAndMarginDataContentRow
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    dataLoading: {
      type: Boolean,
      default: false
    },
    sortField: {
      type: String,
      default: "product_name"
    },
    sortDirection: {
      type: String,
      default: "asc"
    },
    accountProvider: {
      type: String,
      default: "Amazon Seller Central"
    }
  },
  computed: {},
  data() {
    return {
      // dataLoading: false
      value_fix: false
    };
  },
  methods: {
    onSort(field) {
      const newDirection = field == this.sortField ? this.sortDirection == "asc" ? "desc" : "asc" : "asc";
      const newField = field;
      this.$emit("sort", [newField, newDirection]);
    }
  }
};